;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"0e4dd4f"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

// Sentry is enabled when NEXT_PUBLIC_SENTRY_DSN is set.
// Set NEXT_PUBLIC_SENTRY_DSN to enable; leave unset (or set NEXT_PUBLIC_SENTRY_ENABLED=false) to disable.
const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const enabled = dsn
  ? process.env.NEXT_PUBLIC_SENTRY_ENABLED !== "false"
  : false;

Sentry.init({
  dsn,
  enabled,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
  // Traces disabled by default — set NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE to enable
  tracesSampleRate: Number(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE || 0),
  sampleRate: Number(process.env.NEXT_PUBLIC_SENTRY_ERROR_SAMPLE_RATE || 1),
  beforeSend(event) {
    return event;
  },
});
